/**
 * Generated by orval v8.22.0 🍺
 * Do not edit manually.
 * Curai Superclinical Service
 * OpenAPI spec version: 0.1.0
 */

export const PartnerMatchingRequestMetadataValue = {
  type: "partner_matching_request",
  /** Whether the user explicitly asked to activate a partner membership */
  partner_matching_requested: true,
} as const;
export type PartnerMatchingRequestMetadata =
  typeof PartnerMatchingRequestMetadataValue;
